import { type App } from 'vue'
import { provideContentMenu } from '@/composables/useContentMenu'

export default {
  install: (app: App) => {
    app.mixin({
      setup() {
        provideContentMenu()
      }
    })
  }
} 